import React, { useState } from 'react';
import { SectionHeader, FadeIn, CornerBrackets } from '../ui';
const HELP_OPTIONS = ['Build a custom home', 'Visit a display home', 'Discuss a block of land', 'International client enquiry', 'Something else'];
export function Enquire() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // No backend wired. Markup-only submission for the prototype.
    setSubmitted(true);
  };
  return <section id="enquire" className="py-16 md:py-24 bg-atrium-ivory scroll-mt-24" data-id="element-166">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-167">
        <FadeIn data-id="element-168">
          <SectionHeader eyebrow="Enquire" title="Start your custom home conversation" className="text-center max-w-2xl mx-auto" data-id="element-169" />
          <p className="text-center text-atrium-ink/70 max-w-xl mx-auto -mt-6 mb-12 leading-relaxed" data-id="element-170">
            A private, no obligation conversation with the people who will build
            your home. We usually reply within one business day.
          </p>
        </FadeIn>

        <FadeIn delay={100} data-id="element-171">
          <div className="relative bg-white p-8 md:p-14 shadow-diffuse" data-id="element-172">
            <CornerBrackets color="bronze" data-id="element-173" />

            {submitted ? <div className="text-center py-12" role="status" aria-live="polite" data-id="element-174">
                <h3 className="font-serif text-2xl md:text-3xl text-atrium-green mb-4" data-id="element-175">
                  Thank you for reaching out.
                </h3>
                <p className="text-atrium-ink/70 max-w-md mx-auto" data-id="element-176">
                  A member of the Atrium team will be in touch within one
                  business day. For immediate assistance, call{' '}
                  <a href="tel:+61863108888" className="text-atrium-green underline decoration-atrium-bronze underline-offset-4" data-id="element-177">
                    (08) 6310 8888
                  </a>
                  .
                </p>
              </div> : <form onSubmit={handleSubmit} noValidate aria-label="Enquiry form" data-id="element-178">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-179">
                  <Field id="enquire-first-name" label="First name" name="firstName" type="text" autoComplete="given-name" required data-id="element-180" />
                  <Field id="enquire-last-name" label="Last name" name="lastName" type="text" autoComplete="family-name" required data-id="element-181" />
                  <Field id="enquire-phone" label="Phone" name="phone" type="tel" autoComplete="tel" required data-id="element-182" />
                  <Field id="enquire-email" label="Email" name="email" type="email" autoComplete="email" required data-id="element-183" />

                  {/* Lead qualifier: routes the conversation to the right person */}
                  <div data-id="element-184">
                    <label htmlFor="enquire-help" className="block text-xs font-bold tracking-[0.15em] uppercase text-atrium-green mb-3" data-id="element-185">
                      How can we help
                      <span className="text-atrium-bronze ml-1" aria-hidden="true" data-id="element-186">
                        *
                      </span>
                    </label>
                    <select id="enquire-help" name="help" required aria-required="true" defaultValue="" className="w-full px-4 py-3 bg-atrium-ivory/40 border border-atrium-stone/60 text-atrium-ink focus:outline-none focus:border-atrium-green focus:ring-2 focus:ring-atrium-green/20 transition-colors duration-300 rounded-md appearance-none bg-[length:18px] bg-[right_1rem_center] bg-no-repeat" style={{
                  backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23B9935A' stroke-width='1.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")"
                }} data-id="element-187">
                      <option value="" disabled data-id="element-188">
                        Select an option
                      </option>
                      {HELP_OPTIONS.map(opt => <option key={opt} value={opt} data-id="element-189">
                          {opt}
                        </option>)}
                    </select>
                  </div>

                  <Field id="enquire-suburb" label="Suburb or block" name="suburb" type="text" autoComplete="address-level2" optionalHint="optional" data-id="element-190" />
                </div>

                <div className="mt-6 md:mt-8" data-id="element-191">
                  <label htmlFor="enquire-message" className="block text-xs font-bold tracking-[0.15em] uppercase text-atrium-green mb-3" data-id="element-192">
                    Message
                  </label>
                  <textarea id="enquire-message" name="message" rows={5} required placeholder="Tell us about your project, your block, or what stage you are at." className="w-full px-4 py-3 bg-atrium-ivory/40 border border-atrium-stone/60 text-atrium-ink placeholder:text-atrium-ink/40 focus:outline-none focus:border-atrium-green focus:ring-2 focus:ring-atrium-green/20 transition-colors duration-300 rounded-md resize-y" data-id="element-193" />
                </div>

                <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-194">
                  <button type="submit" className="inline-flex items-center justify-center bg-atrium-green text-atrium-ivory px-8 py-4 rounded-md hover:bg-opacity-90 transition-editorial duration-600 font-medium tracking-wide text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atrium-bronze focus-visible:ring-offset-2" data-id="element-195">
                    Send Enquiry
                  </button>
                  <p className="text-xs text-atrium-ink/50 leading-relaxed" data-id="element-196">
                    Prefer to talk? Call{' '}
                    <a href="tel:+61863108888" className="text-atrium-ink hover:text-atrium-green transition-colors" data-id="element-197">
                      (08) 6310 8888
                    </a>{' '}
                    Mon to Fri, 8am to 5pm.
                  </p>
                </div>

                <p className="mt-6 text-xs text-atrium-ink/45 leading-relaxed max-w-2xl" data-id="element-198">
                  Your details stay private and are used only to respond to your
                  enquiry. See our{' '}
                  <a href="#privacy" className="text-atrium-ink/70 hover:text-atrium-green underline decoration-atrium-stone underline-offset-2 transition-colors" data-id="element-199">
                    privacy policy
                  </a>
                  .
                </p>
              </form>}
          </div>
        </FadeIn>
      </div>
    </section>;
}
type FieldProps = {
  id: string;
  label: string;
  name: string;
  type: string;
  autoComplete?: string;
  required?: boolean;
  optionalHint?: string;
};
function Field({
  id,
  label,
  name,
  type,
  autoComplete,
  required,
  optionalHint
}: FieldProps) {
  return <div data-id="element-200">
      <label htmlFor={id} className="block text-xs font-bold tracking-[0.15em] uppercase text-atrium-green mb-3" data-id="element-201">
        {label}
        {required && <span className="text-atrium-bronze ml-1" aria-hidden="true" data-id="element-202">
            *
          </span>}
        {optionalHint && <span className="text-atrium-ink/40 ml-2 font-normal normal-case tracking-normal" data-id="element-203">
            ({optionalHint})
          </span>}
      </label>
      <input id={id} name={name} type={type} autoComplete={autoComplete} required={required} aria-required={required} className="w-full px-4 py-3 bg-atrium-ivory/40 border border-atrium-stone/60 text-atrium-ink placeholder:text-atrium-ink/40 focus:outline-none focus:border-atrium-green focus:ring-2 focus:ring-atrium-green/20 transition-colors duration-300 rounded-md" data-id="element-204" />
    </div>;
}